module.exports = __webpack_public_path__ + "static/media/upcoming-cal.0d7d1e49.svg";